import React, { useState } from 'react';
import { DiscountIcon } from '@fiverr-private/visuals';
import { TabGroup, TabList, Tab } from '@fiverr-private/navigation';
import { Stack } from '@fiverr-private/layout_components';
import { appTranslate } from '../../i18n';
import { BillingCycle } from '../../../type';
import { useResellingProgramsContext } from '../../context';
import { Badge } from '../shared/Badge';

const DEFAULT_MONTH_INDEX = 0;
const billingCycleValues = Object.values(BillingCycle);

export const BillingCycleControl = () => {
    const {
        annualPlanDiscount,
        billingCycleState: { billingCycle, onChangeBillingCycle },
    } = useResellingProgramsContext();

    const [currentIndex, setCurrentIndex] = useState(() => {
        const currentIndex = billingCycleValues.indexOf(billingCycle);

        return currentIndex === -1 ? DEFAULT_MONTH_INDEX : currentIndex;
    });

    const handleChangeIndex = (selectedIndex: number) => {
        setCurrentIndex(selectedIndex);

        const updatedCycle: BillingCycle = billingCycleValues[selectedIndex];

        onChangeBillingCycle(updatedCycle);
    };

    return (
        <TabGroup
            variant="segmentedControlRounded"
            width="fit-content"
            selectedIndex={currentIndex}
            onChange={handleChangeIndex}
        >
            <TabList>
                <Tab fontSize={{ default: 'b_sm', sm: 'b_md' }}>
                    {appTranslate('billing_cycle_control.month.label')}
                </Tab>

                <Tab
                    display="flex"
                    columnGap="2"
                    alignItems="center"
                    paddingY="1"
                    paddingRight={{ default: '6', sm: '1.5' }}
                    fontSize={{ default: 'b_sm', sm: 'b_md' }}
                >
                    <Stack hidden={{ default: false, sm: true }}>
                        <DiscountIcon size="lg" />
                    </Stack>

                    {appTranslate('billing_cycle_control.year.label')}

                    {annualPlanDiscount > 0 && (
                        <Badge hidden={{ default: true, sm: false }}>
                            {appTranslate('billing_cycle_control.year.discount', {
                                params: {
                                    discount: annualPlanDiscount,
                                },
                            })}
                        </Badge>
                    )}
                </Tab>
            </TabList>
        </TabGroup>
    );
};
